<h1 mat-dialog-title>{{data.title}}</h1>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>¡De acuerdo!</button>
</mat-dialog-actions>
